/* Slothy pre-cart complementary popup */
(function () {
  'use strict';
  if (window.__slothyXsInit) return;
  window.__slothyXsInit = true;

  var MAX_PER_ROW = 6;
  var MAX_POPUPS = 3;
  var SHOWN_KEY = 'slothy_xs_shown';
  var COUNT_KEY = 'slothy_xs_count';
  var CASE_COLS = ['pitaka-cases', 'apple-cases', 'otterbox-cases', 'cases', 'כיסויים'];
  var CAM_HANDLES = [
    'מגן-לעדשות-המצלמה-עשוי-זכוכית-לשמירה-על-איכות-הצילום',
    'כיסוי-מלא-לעדשות-מצלמה-אייפון-17-פרו-מקס-ninthpro',
    'כיסוי-מלא-לעדשות-מצלמה-אייפון-17-פרו-ninthpro'
  ];
  var ROWS = [
    { key: 'glass', title: 'מגני מסך ומצלמה', cats: ['glass', 'camera'] },
    { key: 'case', title: 'מגנים אחוריים', cats: ['case'] },
    { key: 'charge', title: 'מטענים ועוד', cats: ['charger', 'other'] }
  ];

  var holdDrawer = false;
  var pendingOpen = null;
  var currentRoot = null;
  var busy = false;

  function rootPath() {
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return r.replace(/\/$/, '') || '';
  }
  function addUrl() {
    return rootPath() + '/cart/add.js';
  }
  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      return r.ok ? r.json() : null;
    }).catch(function () { return null; });
  }
  function money(cents) {
    cents = Math.round(Number(cents) || 0);
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents);
    return '₪' + Math.round(cents / 100);
  }
  function typeOf(p) {
    return p.product_type || p.type || '';
  }
  function variantCents(v) {
    if (!v || v.price == null || v.price === '') return 0;
    var s = String(v.price);
    if (s.indexOf('.') !== -1) return Math.round(parseFloat(s) * 100);
    var n = Number(v.price);
    if (!isFinite(n)) return 0;
    if (s.length >= 4) return Math.round(n);
    return Math.round(n * 100);
  }
  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (ch) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch];
    });
  }
  function sessionList(key) {
    try {
      return (sessionStorage.getItem(key) || '').split(',').filter(Boolean);
    } catch (e) { return []; }
  }
  function sessionPush(key, value) {
    try {
      var list = sessionList(key);
      if (list.indexOf(String(value)) === -1) list.push(String(value));
      sessionStorage.setItem(key, list.join(','));
    } catch (e) {}
  }
  function popupCount() {
    try { return parseInt(sessionStorage.getItem(COUNT_KEY) || '0', 10) || 0; }
    catch (e) { return 0; }
  }
  function bumpPopupCount() {
    try { sessionStorage.setItem(COUNT_KEY, String(popupCount() + 1)); }
    catch (e) {}
  }

  function drawerEl() {
    return document.querySelector('m-cart-drawer');
  }
  function drawerIsOpen() {
    var d = drawerEl();
    return !!(d && d.classList.contains('m-cart-drawer--active'));
  }
  function patchDrawer() {
    var Ctor = window.customElements && customElements.get('m-cart-drawer');
    if (!Ctor || Ctor.prototype.__slothyXsPatched) return;
    Ctor.prototype.__slothyXsPatched = true;
    var orig = Ctor.prototype.open;
    Ctor.prototype.open = function (triggeredBy) {
      if (holdDrawer) {
        var self = this;
        pendingOpen = function () { orig.call(self, triggeredBy); };
        return;
      }
      return orig.call(this, triggeredBy);
    };
  }
  function releaseDrawer(openIt) {
    holdDrawer = false;
    document.documentElement.classList.remove('slothy-xs-open');
    var fn = pendingOpen;
    pendingOpen = null;
    if (openIt && typeof fn === 'function') {
      fn();
    } else if (openIt) {
      var d = drawerEl();
      if (d && typeof d.open === 'function') d.open();
    }
  }

  function detectModel(blob) {
    var hay = String(blob || '').toLowerCase();
    var rules = [
      ['18 pro max', '18 פרו מקס', 'pro-max', 'iphone'],
      ['18 pro', '18 פרו', 'pro', 'iphone'],
      ['18 air', '18 אייר', 'air', 'iphone'],
      ['iphone 18', 'אייפון 18', 'base', 'iphone'],
      ['17e', '17e', 'e', 'iphone'],
      ['17 pro max', '17 פרו מקס', 'pro-max', 'iphone'],
      ['17 air', '17 אייר', 'air', 'iphone'],
      ['17 pro', '17 פרו', 'pro', 'iphone'],
      ['iphone 17', 'אייפון 17', 'base', 'iphone'],
      ['16 pro max', '16 פרו מקס', 'pro-max', 'iphone'],
      ['16 pro', '16 פרו', 'pro', 'iphone'],
      ['iphone 16', 'אייפון 16', 'base', 'iphone'],
      ['15 pro max', '15 פרו מקס', 'pro-max', 'iphone'],
      ['15 pro', '15 פרו', 'pro', 'iphone'],
      ['iphone 15', 'אייפון 15', 'base', 'iphone'],
      ['14 pro max', '14 פרו מקס', 'pro-max', 'iphone'],
      ['14 pro', '14 פרו', 'pro', 'iphone'],
      ['iphone 14', 'אייפון 14', 'base', 'iphone'],
      ['13 pro max', '13 פרו מקס', 'pro-max', 'iphone'],
      ['13 pro', '13 פרו', 'pro', 'iphone'],
      ['iphone 13', 'אייפון 13', 'base', 'iphone'],
      ['12 pro max', '12 פרו מקס', 'pro-max', 'iphone'],
      ['iphone 12', 'אייפון 12', 'base', 'iphone'],
      ['iphone 11', 'אייפון 11', 'base', 'iphone'],
      ['s26 ultra', 's26 אולטרה', 'ultra', 'samsung'],
      ['s26 plus', 's26 פלוס', 'plus', 'samsung'],
      ['s26', 's26', 'base', 'samsung'],
      ['s25 ultra', 's25 אולטרה', 'ultra', 'samsung'],
      ['s25 plus', 's25 פלוס', 'plus', 'samsung'],
      ['s25', 's25', 'base', 'samsung'],
      ['s24 ultra', 's24 אולטרה', 'ultra', 'samsung'],
      ['s24 plus', 's24 פלוס', 'plus', 'samsung'],
      ['s24', 's24', 'base', 'samsung']
    ];
    for (var i = 0; i < rules.length; i++) {
      var r = rules[i];
      if (hay.indexOf(r[0]) !== -1 || hay.indexOf(r[1]) !== -1) {
        return { en: r[0], he: r[1], exact: r[2], family: r[3] };
      }
    }
    return null;
  }
  function hayOf(p) {
    var tags = Array.isArray(p.tags) ? p.tags.join(',') : String(p.tags || '');
    return ((p.title || '') + ',' + (p.handle || '') + ',' + tags + ',' + typeOf(p)).toLowerCase();
  }
  function matchesModel(p, model) {
    if (!model) return true;
    var hay = hayOf(p);
    var title = ((p.title || '') + ' ' + (p.handle || '')).toLowerCase();
    var uni = false;
    if (model.family === 'iphone' && /למגוון דגמי אייפון|לדגמי אייפון/.test(hay)) uni = true;
    if (model.family === 'samsung' && /למגוון דגמי סמסונג|לדגמי סמסונג/.test(hay)) uni = true;
    var hit = uni || hay.indexOf(model.en) !== -1 || (model.he && hay.indexOf(model.he) !== -1);
    if (!hit) return false;
    if (uni) return true;
    if (model.family === 'samsung') {
      if (model.exact === 'base' && /ultra|plus|\+|פלוס|אולטרה/.test(title)) return false;
      if (model.exact === 'plus' && /ultra|אולטרה/.test(title)) return false;
      if (model.exact === 'ultra' && !/ultra|אולטרה/.test(title)) return false;
      return true;
    }
    if (model.exact === 'base' && /pro|air|\bmax\b|plus|פרו|אייר|מקס/.test(title)) return false;
    if (model.exact === 'pro' && /pro max|פרו מקס|air|אייר/.test(title)) return false;
    if (model.exact === 'air' && !/air|אייר/.test(title)) return false;
    return true;
  }
  function normalizeType(t) {
    t = String(t || '').toLowerCase();
    if (t.indexOf('screen') !== -1 || t.indexOf('מגן מסך') !== -1) return 'screen protector';
    if (t.indexOf('case') !== -1 || t.indexOf('כיסוי') !== -1) return 'case';
    if (t.indexOf('charger') !== -1 || t.indexOf('cable') !== -1 || t.indexOf('מטען') !== -1 || t.indexOf('כבל') !== -1) return 'charger';
    if (t.indexOf('headphone') !== -1 || t.indexOf('אוזנ') !== -1) return 'headphones';
    if (t.indexOf('speaker') !== -1 || t.indexOf('רמקול') !== -1) return 'speaker';
    if (t.indexOf('adapter') !== -1) return 'adapter';
    if (t.indexOf('tripod') !== -1) return 'tripod';
    if (t.indexOf('smartphone') !== -1 || t.indexOf('סמארטפון') !== -1) return 'smartphone';
    if (t.indexOf('tablet') !== -1 || t.indexOf('טאבלט') !== -1) return 'tablet';
    return t;
  }
  function vendorOf(p) {
    return String(p.vendor || '').toLowerCase();
  }
  function isAppleVendor(p) {
    var v = vendorOf(p);
    return v === 'apple' || v === 'אפל';
  }
  function isPitaka(p) {
    return vendorOf(p) === 'pitaka';
  }
  function catOf(p) {
    var hay = hayOf(p);
    var t = normalizeType(typeOf(p));
    if (/עדשות|camera lens|מגן מצלמה|לעדשות/.test(hay)) return 'camera';
    if (t === 'screen protector') return 'glass';
    if (t === 'case') return 'case';
    if (t === 'charger' || t === 'adapter') return 'charger';
    return 'other';
  }
  /* 10% PITAKA + Apple cases/protectors; 15% other accessories; 0 = skip (phones/tablets/AirPods). */
  function discountRate(p) {
    var t = normalizeType(typeOf(p));
    if (t === 'smartphone' || t === 'tablet') return 0;
    if (isPitaka(p)) return 0.1;
    if (isAppleVendor(p)) {
      if (t === 'case' || t === 'screen protector' || catOf(p) === 'camera') return 0.1;
      return 0;
    }
    var accTypes = ['case', 'screen protector', 'charger', 'headphones', 'speaker', 'adapter', 'tripod'];
    var tags = Array.isArray(p.tags) ? p.tags.join(',').toLowerCase() : String(p.tags || '').toLowerCase();
    if (accTypes.indexOf(t) !== -1 || tags.indexOf('accessories') !== -1 || tags.indexOf('אביזרים') !== -1) return 0.15;
    if (catOf(p) === 'camera' || catOf(p) === 'glass') return 0.15;
    return 0;
  }
  function firstAvail(p) {
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) {
      if (vs[i].available !== false) return vs[i];
    }
    return vs[0] || null;
  }
  function variantFitsModel(v, model) {
    if (!model) return true;
    var hay = String(v.title || '').toLowerCase();
    if (!hay || hay === 'default title') return true;
    var hit = hay.indexOf(model.en) !== -1 || (model.he && hay.indexOf(model.he) !== -1);
    if (!hit) return false;
    if (model.exact === 'base' && /pro|air|\bmax\b|plus|פרו|אייר|מקס/.test(hay)) return false;
    if (model.exact === 'pro' && /pro max|פרו מקס|air|אייר/.test(hay)) return false;
    if (model.exact === 'air' && !/air|אייר/.test(hay)) return false;
    return true;
  }
  function pickVariant(p, model) {
    var vs = p.variants || [];
    if (model) {
      for (var i = 0; i < vs.length; i++) {
        var v = vs[i];
        if (v.available === false) continue;
        if (variantFitsModel(v, model)) return v;
      }
    }
    return firstAvail(p);
  }
  function absUrl(src) {
    if (!src) return '';
    src = String(src);
    if (src.indexOf('//') === 0) return 'https:' + src;
    return src;
  }
  function imgSrc(p) {
    if (typeof p.featured_image === 'string' && p.featured_image) return absUrl(p.featured_image);
    if (p.featured_image && p.featured_image.src) return absUrl(p.featured_image.src);
    if (p.image && (p.image.src || typeof p.image === 'string')) {
      return absUrl(typeof p.image === 'string' ? p.image : p.image.src);
    }
    if (p.images && p.images[0]) {
      var im = p.images[0];
      return absUrl(typeof im === 'string' ? im : (im.src || ''));
    }
    if (p.featured_image_url) return absUrl(p.featured_image_url);
    return '';
  }
  function productIdOf(p) {
    return p.id || p.product_id;
  }
  function inCart(p, cartPids) {
    return cartPids.indexOf(',' + productIdOf(p) + ',') !== -1;
  }
  function uniqueById(list) {
    var seen = {};
    var out = [];
    list.forEach(function (p) {
      var id = productIdOf(p);
      if (!id || seen[id]) return;
      seen[id] = 1;
      out.push(p);
    });
    return out;
  }

  function normalizeAdded(data) {
    if (!data || data.status) return null;
    if (data.product_id && (data.product_title || data.title) && data.handle) return data;
    if (Array.isArray(data.items) && data.items.length) return data.items[data.items.length - 1];
    return null;
  }
  function shouldSkip(item) {
    if (!item) return true;
    if (document.body && document.body.classList.contains('template-cart')) return true;
    if (window.MinimogSettings && MinimogSettings.templateName === 'cart') return true;
    if (drawerIsOpen()) return true;
    if (popupCount() >= MAX_POPUPS) return true;
    var pid = String(item.product_id || item.id || '');
    if (pid && sessionList(SHOWN_KEY).indexOf(pid) !== -1) return true;
    return false;
  }

  function rowsForAdded(type) {
    type = normalizeType(type);
    return ROWS.filter(function (row) {
      if (type === 'case' && row.key === 'case') return false;
      if (type === 'screen protector' && row.key === 'glass') return false;
      if ((type === 'charger' || type === 'adapter') && row.key === 'charge') return false;
      return true;
    });
  }

  function usableInRow(p, row, model, recIds, cartPids, addedId) {
    if (!p || productIdOf(p) === addedId) return false;
    if (inCart(p, cartPids)) return false;
    if (discountRate(p) <= 0) return false;
    if (row.cats.indexOf(catOf(p)) === -1) return false;
    if (!pickVariant(p, model)) return false;
    var cat = catOf(p);
    if (cat === 'charger') {
      var ch = hayOf(p);
      if (/watch|שעון|apple watch|iwatch|macbook|מקבוק/.test(ch)) return false;
      if (model && model.family === 'iphone' && /samsung|galaxy|סמסונג/.test(ch)) return false;
      if (model && model.family === 'samsung' && /lightning|\biphone\b|אייפון/.test(ch)) return false;
    }
    if (cat === 'case' || cat === 'glass' || cat === 'camera') {
      if (cat === 'camera' && /למגוון דגמ/.test(hayOf(p))) return true;
      if (model) return matchesModel(p, model);
      return !!recIds[productIdOf(p)];
    }
    return true;
  }

  function pickRow(pool, row, model, recIds, cartPids, addedId) {
    var usable = uniqueById(pool).filter(function (p) {
      return usableInRow(p, row, model, recIds, cartPids, addedId);
    });
    usable.sort(function (a, b) {
      if (row.key === 'charge') {
        var bankA = /powerstation|power bank|powerbank|סוללת גיבוי/.test(hayOf(a)) ? 1 : 0;
        var bankB = /powerstation|power bank|powerbank|סוללת גיבוי/.test(hayOf(b)) ? 1 : 0;
        if (bankA !== bankB) return bankA - bankB;
        return variantCents(pickVariant(a, model)) - variantCents(pickVariant(b, model));
      }
      var pa = isPitaka(a) || isAppleVendor(a) ? 0 : 1;
      var pb = isPitaka(b) || isAppleVendor(b) ? 0 : 1;
      if (pa !== pb) return pa - pb;
      return variantCents(pickVariant(b, model)) - variantCents(pickVariant(a, model));
    });
    var vendorCount = {};
    var picked = [];
    usable.forEach(function (p) {
      if (picked.length >= MAX_PER_ROW) return;
      var v = vendorOf(p) || 'x';
      vendorCount[v] = vendorCount[v] || 0;
      if (vendorCount[v] >= 2) return;
      vendorCount[v] += 1;
      picked.push(p);
    });
    return picked;
  }

  function cardHtml(p, model) {
    var v = pickVariant(p, model);
    if (!v) return '';
    var cents = variantCents(v);
    var rate = discountRate(p);
    var sale = Math.round(cents * (1 - rate));
    var pct = Math.round(rate * 100);
    var url = p.url || (rootPath() + '/products/' + p.handle);
    var img = imgSrc(p);
    return (
      '<article class="slothy-xs__card" data-variant-id="' + v.id + '" data-product-id="' + productIdOf(p) + '">' +
        '<a class="slothy-xs__media" href="' + escapeHtml(url) + '"><img src="' + escapeHtml(img) + '" alt="" width="160" height="160"></a>' +
        '<div class="slothy-xs__info">' +
          '<a class="slothy-xs__name" href="' + escapeHtml(url) + '">' + escapeHtml(p.title) + '</a>' +
          '<div class="slothy-xs__meta">' +
            '<div class="slothy-xs__price"><span class="slothy-xs__now">' + money(sale) + '</span><span class="slothy-xs__was">' + money(cents) + '</span></div>' +
            '<span class="slothy-xs__badge">' + pct + '%</span>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="slothy-xs__add" data-variant-id="' + v.id + '">הוסיפו</button>' +
      '</article>'
    );
  }

  function recUrl(productId, intent) {
    return rootPath() + '/recommendations/products.json?product_id=' + encodeURIComponent(productId) +
      '&limit=10&intent=' + encodeURIComponent(intent);
  }
  function colUrl(handle, page) {
    return rootPath() + '/collections/' + encodeURIComponent(handle) + '/products.json?limit=50&page=' + page;
  }
  function flattenProducts(pages) {
    var pool = [];
    (pages || []).forEach(function (d) {
      var list = (d && (d.products || d.resources)) || [];
      if (d && d.id && d.handle && !list.length) list = [d];
      list.forEach(function (p) { if (p) pool.push(p); });
    });
    return pool;
  }
  function loadPool(item, model) {
    var pid = item.product_id || item.id;
    var recsP = Promise.all([
      getJSON(recUrl(pid, 'complementary')),
      getJSON(recUrl(pid, 'related'))
    ]).then(flattenProducts);
    var reqs = [getJSON(colUrl('chargers', 1)), getJSON(colUrl('screen-protector', 1))];
    CASE_COLS.forEach(function (h) {
      reqs.push(getJSON(colUrl(h, 1)));
      reqs.push(getJSON(colUrl(h, 2)));
      reqs.push(getJSON(colUrl(h, 3)));
    });
    var extraP = Promise.all(reqs).then(flattenProducts);
    var camP = Promise.all(CAM_HANDLES.map(function (h) {
      return getJSON(rootPath() + '/products/' + encodeURIComponent(h) + '.js');
    })).then(function (list) { return list.filter(Boolean); });
    var searchP = Promise.resolve([]);
    if (model) {
      var q = model.en + ' כיסוי';
      searchP = getJSON(rootPath() + '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=10').then(function (d) {
        var list = ((((d || {}).resources || {}).results || {}).products) || [];
        return Promise.all(list.map(function (p) {
          if (!p || !p.handle) return null;
          return getJSON(rootPath() + '/products/' + encodeURIComponent(p.handle) + '.js');
        })).then(function (found) { return found.filter(Boolean); });
      });
    }
    return Promise.all([recsP, extraP, camP, searchP]).then(function (quad) {
      var recs = quad[0];
      var recIds = {};
      recs.forEach(function (p) { recIds[productIdOf(p)] = 1; });
      return { pool: recs.concat(quad[1], quad[2], quad[3]), recIds: recIds };
    });
  }

  function enrichAdded(item) {
    if (!item.handle) return Promise.resolve(item);
    return getJSON(rootPath() + '/products/' + encodeURIComponent(item.handle) + '.js').then(function (p) {
      if (!p) return item;
      item.tags = p.tags;
      item.product_type = item.product_type || p.type || p.product_type;
      item.vendor = item.vendor || p.vendor;
      item.title = item.product_title || item.title || p.title;
      return item;
    });
  }
  function currentCartPids() {
    return getJSON(rootPath() + '/cart.js').then(function (cart) {
      var ids = ',';
      ((cart && cart.items) || []).forEach(function (it) {
        ids += (it.product_id || '') + ',';
      });
      return ids;
    });
  }

  function rootEl() {
    if (currentRoot) return currentRoot;
    currentRoot = document.getElementById('slothy-xs');
    return currentRoot;
  }
  function resetFooter() {
    var el = rootEl();
    if (!el) return;
    var go = el.querySelector('.slothy-xs__go');
    var skip = el.querySelector('.slothy-xs__skip');
    if (go) {
      go.hidden = true;
      go.textContent = 'המשך לעגלה';
    }
    if (skip) skip.hidden = false;
    el.querySelectorAll('.slothy-xs__tab-badge').forEach(function (b) {
      b.hidden = true;
      b.textContent = '';
    });
  }
  function syncFooter() {
    var el = rootEl();
    if (!el) return;
    var n = el.querySelectorAll('.slothy-xs__add.is-added').length;
    var go = el.querySelector('.slothy-xs__go');
    var skip = el.querySelector('.slothy-xs__skip');
    if (go) {
      go.hidden = n === 0;
      go.textContent = n > 1 ? 'המשך לעגלה · ' + n + ' נוספו' : 'המשך לעגלה';
    }
    if (skip) skip.hidden = n > 0;
    el.querySelectorAll('.slothy-xs__cat').forEach(function (panel) {
      var key = panel.getAttribute('data-panel');
      var count = panel.querySelectorAll('.slothy-xs__add.is-added').length;
      var badge = el.querySelector('.slothy-xs__tab[data-tab="' + key + '"] .slothy-xs__tab-badge');
      if (!badge) return;
      if (count) {
        badge.hidden = false;
        badge.textContent = String(count);
      } else {
        badge.hidden = true;
        badge.textContent = '';
      }
    });
  }
  function activateTab(key) {
    var el = rootEl();
    if (!el) return;
    el.querySelectorAll('.slothy-xs__tab').forEach(function (tab) {
      tab.classList.toggle('is-active', tab.getAttribute('data-tab') === key);
    });
    el.querySelectorAll('.slothy-xs__cat').forEach(function (panel) {
      panel.classList.toggle('is-active', panel.getAttribute('data-panel') === key);
    });
  }
  function closePopup(openCart) {
    var el = rootEl();
    if (el) el.classList.remove('is-open');
    busy = false;
    releaseDrawer(openCart !== false);
  }
  function openPopup(built) {
    var el = rootEl();
    if (!el) {
      closePopup(true);
      return;
    }
    var tabs = el.querySelector('.slothy-xs__tabs');
    var list = el.querySelector('.slothy-xs__list');
    if (tabs) {
      tabs.innerHTML = built.tabs;
      tabs.hidden = !built.tabs;
    }
    if (list) list.innerHTML = built.body;
    resetFooter();
    el.classList.add('is-open');
    document.documentElement.classList.add('slothy-xs-open');
    bumpPopupCount();
  }

  function renderRows(pool, recIds, model, cartPids, addedId, addedType) {
    var rows = [];
    rowsForAdded(addedType).forEach(function (row) {
      var picked = pickRow(pool, row, model, recIds, cartPids, addedId);
      if (picked.length) rows.push({ row: row, products: picked });
    });
    if (!rows.length) return null;
    var tabs = rows.map(function (r, i) {
      return '<button type="button" class="slothy-xs__tab' + (i === 0 ? ' is-active' : '') +
        '" data-tab="' + r.row.key + '" role="tab">' + escapeHtml(r.row.title) +
        '<span class="slothy-xs__tab-badge" hidden></span></button>';
    }).join('');
    var body = rows.map(function (r, i) {
      return '<div class="slothy-xs__cat' + (i === 0 ? ' is-active' : '') + '" data-panel="' + r.row.key + '">' +
        '<div class="slothy-xs__grid">' +
        r.products.map(function (p) { return cardHtml(p, model); }).join('') +
        '</div></div>';
    }).join('');
    return { tabs: tabs, body: body };
  }

  function runForItem(item) {
    if (shouldSkip(item) || busy) {
      holdDrawer = false;
      if (pendingOpen) releaseDrawer(true);
      return;
    }
    busy = true;
    holdDrawer = true;
    enrichAdded(item).then(function (full) {
      var blob = [full.product_title || full.title, full.variant_title, full.handle, Array.isArray(full.tags) ? full.tags.join(',') : full.tags].join(',');
      var model = detectModel(blob);
      var addedId = full.product_id || full.id;
      return Promise.all([loadPool(full, model), currentCartPids()]).then(function (pair) {
        var built = renderRows(pair[0].pool, pair[0].recIds, model, pair[1], addedId, typeOf(full));
        if (!built) {
          busy = false;
          releaseDrawer(true);
          return;
        }
        sessionPush(SHOWN_KEY, String(addedId));
        openPopup(built);
      });
    }).catch(function (err) {
      console.error('[slothy-xs]', err);
      busy = false;
      releaseDrawer(true);
    });
  }

  function maybeInterceptAdd(url, data) {
    if (window.__slothyXsIgnoreAdd) return;
    if (!/\/cart\/add/.test(String(url || ''))) return;
    var item = normalizeAdded(data);
    if (!item) return;
    runForItem(item);
  }

  function installFetchHook() {
    var orig = window.fetch;
    if (typeof orig !== 'function' || orig.__slothyXs) return;
    var wrapped = function () {
      var args = arguments;
      var url = '';
      try { url = String((args[0] && args[0].url) || args[0] || ''); } catch (e) {}
      var isAdd = /\/cart\/add/.test(url) && !window.__slothyXsIgnoreAdd && !drawerIsOpen();
      if (isAdd) holdDrawer = true;
      return orig.apply(this, args).then(function (res) {
        if (isAdd) {
          if (!res.ok) {
            holdDrawer = false;
            return res;
          }
          res.clone().json().then(function (data) {
            maybeInterceptAdd(url, data);
          }).catch(function () {
            holdDrawer = false;
            if (pendingOpen) releaseDrawer(true);
          });
        }
        return res;
      });
    };
    wrapped.__slothyXs = true;
    window.fetch = wrapped;
  }

  function addOffer(variantId, btn) {
    if (!variantId || window.__slothyXsIgnoreAdd) return;
    window.__slothyXsIgnoreAdd = true;
    if (btn) {
      btn.disabled = true;
      btn.textContent = '...';
    }
    fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw res.d;
        if (btn) {
          btn.textContent = 'נוסף';
          btn.classList.add('is-added');
        }
        syncFooter();
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
      })
      .catch(function (err) {
        console.error('[slothy-xs-add]', err);
        if (btn) {
          btn.disabled = false;
          btn.textContent = 'הוסיפו';
        }
      })
      .finally(function () {
        window.__slothyXsIgnoreAdd = false;
      });
  }

  function bindUi() {
    var el = rootEl();
    if (!el || el.__bound) return;
    el.__bound = true;
    el.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('.slothy-xs__backdrop') || t.closest('[data-xs-close]')) {
        e.preventDefault();
        closePopup(true);
        return;
      }
      var tab = t.closest('.slothy-xs__tab');
      if (tab) {
        e.preventDefault();
        activateTab(tab.getAttribute('data-tab'));
        return;
      }
      var add = t.closest('.slothy-xs__add');
      if (add) {
        e.preventDefault();
        addOffer(add.getAttribute('data-variant-id'), add);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && el.classList.contains('is-open')) closePopup(true);
    });
  }

  function boot() {
    patchDrawer();
    installFetchHook();
    bindUi();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  setTimeout(patchDrawer, 400);
})();
